import React from 'react';
import { Info, Activity } from 'lucide-react';

/**
 * Visual badge to distinguish LIVE data (real sensor / monitoring records)
 * from EMPTY data (no real records persisted yet).
 *
 * Usage:
 *   <DataSourceBadge source="live" />
 *   <DataSourceBadge source="empty" />
 *   <DataSourceBadge source="empty" label="Pending Live Batch Data" />
 *
 * The legacy `source="demo"` value is treated as `empty` so older callers
 * don't break — but new code should pass `empty` explicitly.
 */
const DataSourceBadge = ({ source = 'live', label, className = '', size = 'sm' }) => {
  const isLive = source === 'live';
  const Icon = isLive ? Activity : Info;
  const text = label || (isLive ? 'Live Data' : 'Pending Live Data');
  const sizing =
    size === 'xs'
      ? 'text-[10px] px-1.5 py-0.5'
      : 'text-[11px] px-2 py-0.5';

  return (
    <span
      data-testid={`data-source-${isLive ? 'live' : 'empty'}`}
      className={`inline-flex items-center gap-1 rounded-full font-medium uppercase tracking-wide border ${sizing} ${
        isLive
          ? 'bg-emerald-50 border-emerald-200 text-emerald-700'
          : 'bg-slate-100 border-slate-200 text-slate-600'
      } ${className}`}
    >
      <Icon className={size === 'xs' ? 'w-2.5 h-2.5' : 'w-3 h-3'} />
      {text}
    </span>
  );
};

export default DataSourceBadge;
